import useSettingsStore from '@/store/modules/settings'
import useUserStore from '@/store/modules/user'
import { getRuntimeApiBaseUrl } from '@/utils/runtime-config'
import axios from 'axios'
// import qs from 'qs'
import { toast } from 'vue-sonner'

const api = axios.create({
  baseURL: (import.meta.env.DEV && import.meta.env.VITE_OPEN_PROXY) ? '/proxy/' : getRuntimeApiBaseUrl(import.meta.env.VITE_APP_API_BASEURL),
  timeout: 1000 * 60,
  responseType: 'json',
})

api.interceptors.request.use(
  (request) => {
    // 全局拦截请求发送前提交的参数
    const settingsStore = useSettingsStore()
    const userStore = useUserStore()
    // 设置请求头
    if (request.headers) {
      const domain = window.location.hostname
      // 从当前 URL 中提取查询参数
      const params = new URLSearchParams(window.location.search)
      const tenant = import.meta.env.DEV ? '653865331516952576' : params.get('supplier') // supplier后面跟的是租户id,而不是供应商id
      // const tenant = import.meta.env.DEV ? '1000' : params.get('supplier')
      // 如果 tenant 存在，则将它添加到请求头中
      if (tenant) {
        request.headers['X-Tenant'] = tenant
      }

      // 将域名添加到请求头中，例如使用自定义 header 'X-Domain'
      request.headers['X-Domain'] = domain
      request.headers['X-Type'] = 'supplier'
      request.headers['Accept-Language'] = settingsStore.lang
      if (userStore.isLogin) {
        request.headers.Authorization = `Bearer ${userStore.token}`
      }
    }
    // 是否将 POST 请求参数进行字符串化处理
    if (request.method === 'post') {
      // request.data = qs.stringify(request.data, {
      //   arrayFormat: 'brackets',
      // })
    }
    return request
  },
)

api.interceptors.response.use(
  (response) => {
    /**
     * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
     * 假设返回数据格式为：{ status: 1, error: '', data: {} }
     * 规则是当 status 为 1 时表示请求成功，为 0 时表示接口需要登录或者登录状态失效，需要重新登录
     * 请求出错时 error 会返回错误信息
     */
    // 特殊处理导出请求（二进制响应）
    if (response.config.responseType === 'blob' || response.config.url?.includes('export')) {
      return response
    }
    if (response.data.status === 1) {
      if (response.data.error !== '') {
        toast.warning('Warning', {
          description: response.data.error,
        })
        return Promise.reject(response.data)
      }
    }
    else if (response.data.status === -1) {
      toast.error('Error', {
        description: response.data.error,
      })
      return Promise.reject(response.data)
    }
    else {
      useUserStore().requestLogout()
    }
    return Promise.resolve(response.data)
  },
  (error) => {
    // 特殊处理导出请求的错误
    if (error.config?.responseType === 'blob' || error.config?.url?.includes('export')) {
      return Promise.reject(error)
    }
    if (error.status === 401) {
      useUserStore().requestLogout()
      throw error
    }
    let message = error.message
    if (message === 'Network Error') {
      message = '后端网络故障'
    }
    else if (message.includes('timeout')) {
      message = '接口请求超时'
    }
    else if (message.includes('Request failed with status code')) {
      message = `接口${message.substr(message.length - 3)}异常`
    }
    toast.error('Error', {
      description: message,
    })
    return Promise.reject(error)
  },
)

export default api
